import { useI18n, withLocalePrefix, getLocalizedPath } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { CheckCircle, Home } from "lucide-react";
import { Footer } from "@/components/Footer";

export default function AccountDeletedPage() {
    const { t, locale } = useI18n();

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <main className="flex-1 flex items-center justify-center p-4">
                <div className="max-w-md w-full bg-card p-8 rounded-lg shadow-lg border border-border text-center animate-in fade-in zoom-in duration-500">
                    <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
                        <CheckCircle className="w-12 h-12 text-green-600" />
                    </div>

                    <h1 className="text-3xl font-bold mb-4">{t("account.deletedTitle")}</h1>
                    <p className="text-muted-foreground mb-8 text-lg">
                        {t("account.deletedMessage")}
                    </p>

                    <div className="flex flex-col gap-3">
                        <Button asChild className="w-full gap-2">
                            <Link to={withLocalePrefix("/", locale)}>
                                <Home className="w-4 h-4" />
                                {t("account.backToHome")}
                            </Link>
                        </Button>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
